<template>
  <b-modal
    v-model="showModal"
    size="lg"
    id="crtcreator-resource-modal"
    :title="edited.id ? 'Edit resource' : 'Add resource'"
    :ok-title="isFormLoading ? 'Saving...' : 'Save'"
    :ok-disabled="isFormLoading"
    cancel-variant="outline-secondary"
    @ok="onSubmit($event)"
  >
    <b-form>
      <b-form-group label="Name" label-for="resource-name">
        <b-form-input id="resource-name" v-model="edited.name" placeholder="Name" />
        <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
      </b-form-group>
      <b-form-group label="Social resource type" label-for="resource-type">
        <b-form-select
          id="resource-type"
          v-model="edited.social_resource_type_id"
          :options="typeOptions"
        />
      </b-form-group>
      <b-form-group label="URL" label-for="resource-url">
        <b-form-input id="resource-url" v-model="edited.url" placeholder="https://..." />
      </b-form-group>
      <b-form-group label="ID Key" label-for="resource-id-key">
        <b-form-input id="resource-id-key" v-model="edited.id_key" />
      </b-form-group>
      <b-form-group label="Access token" label-for="resource-token">
        <b-form-textarea id="resource-token" v-model="edited.access_token" rows="3" />
      </b-form-group>
      <b-form-checkbox v-model="edited.is_active">
        Active
      </b-form-checkbox>
    </b-form>
  </b-modal>
</template>

<script>
import axios from '@/libs/axios'
import {
  BForm, BFormCheckbox, BFormGroup, BFormInput, BFormSelect, BFormTextarea, BModal,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { toastFailure, toastSuccess } from '@/libs/toastification'

const defaults = () => ({
  id: null,
  name: '',
  social_resource_type_id: null,
  url: '',
  id_key: '',
  access_token: '',
  is_active: false,
})

export default {
  components: {
    BForm, BFormCheckbox, BFormGroup, BFormInput, BFormSelect, BFormTextarea, BModal,
  },
  props: {
    record: { type: Object, default: null },
    clickDate: { type: Date, default: null },
  },
  data() {
    return {
      showModal: false,
      isFormLoading: false,
      edited: defaults(),
      errors: {},
      socialResourceTypes: [],
    }
  },
  computed: {
    typeOptions() {
      return [
        { value: null, text: 'None' },
        ...(this.socialResourceTypes || []).map((t) => ({ value: t.id, text: t.name })),
      ]
    },
  },
  watch: {
    async clickDate() {
      this.errors = {}
      if (!this.socialResourceTypes.length) {
        try {
          const response = await axios.get('api/social-resource-types')
          this.socialResourceTypes = response.data?.data ?? response.data ?? []
        } catch (e) {
          this.socialResourceTypes = []
        }
      }
      if (this.record) {
        this.edited = {
          id: this.record.id,
          name: this.record.name || '',
          social_resource_type_id: this.record.social_resource_type_id || null,
          url: this.record.url || '',
          id_key: this.record.id_key || '',
          access_token: this.record.access_token || '',
          is_active: Boolean(this.record.is_active),
        }
      } else {
        this.edited = defaults()
      }
      this.showModal = true
    },
  },
  methods: {
    ...mapActions({
      addItem: 'crtcreator/resources/addItem',
      updateItem: 'crtcreator/resources/updateItem',
    }),
    async onSubmit(event) {
      event.preventDefault()
      this.errors = {}
      if (!String(this.edited.name || '').trim()) {
        this.errors.name = 'Name is required'
        return
      }
      this.isFormLoading = true
      const payload = {
        name: this.edited.name,
        social_resource_type_id: this.edited.social_resource_type_id || null,
        url: this.edited.url || null,
        id_key: this.edited.id_key || null,
        access_token: this.edited.access_token || null,
        is_active: Boolean(this.edited.is_active),
      }
      try {
        if (this.edited.id) {
          await this.updateItem({ id: this.edited.id, payload })
          toastSuccess('Successfully updated')
        } else {
          await this.addItem(payload)
          toastSuccess('Successfully added')
        }
        this.showModal = false
      } catch (e) {
        toastFailure('Failed to save')
      } finally {
        this.isFormLoading = false
      }
    },
  },
}
</script>
